<div class="fixed-width-modal">
    <form enctype="multipart/form-data" [formGroup]="fileForm" (ngSubmit)="confirm()">
        <div class="dialog-header d-flex justify-content-between align-items-center">
            <h1 mat-dialog-title class="mb-0">{{ dialogTitle }}</h1>
            <button type="button" mat-icon-button [disabled]="isBusy" (click)="closeDialog()" aria-label="Close dialog">
                <mat-icon>close</mat-icon>
            </button>
        </div>

        <div mat-dialog-content>
            <p class="mb-3"><small>{{ dialogDescription }}</small></p>
            <p class="mb-3" *ngIf="errorMessage | async" role="alert">
                <small class="text-danger">{{ errorMessage | async }}</small>
            </p>

            <div class="col-12">
                <input
                    type="file"
                    class="file-input"
                    [accept]="acceptedFileTypes"
                    (change)="onFileSelected($event)"
                    #fileUpload
                    formControlName="file"
                    multiple
                />

                <div class="file-upload">
                    <button
                        mat-flat-button
                        color="primary"
                        class="me-2"
                        type="button"
                        [disabled]="uploading || submitting"
                        (click)="fileUpload.click()"
                    >
                        Select Files
                    </button>
                    {{ files.length > 0 ? (files.length + ' file(s) selected') : 'No files selected.' }}
                </div>

                <div class="upload-limits-warning mt-2 mb-2" role="note">
                    <mat-icon class="warning-icon" aria-hidden="true">warning_amber</mat-icon>
                    <ul class="upload-limits mb-0">
                        <li><small>Min size per file: {{ minFileSizeLabel }}</small></li>
                        <li><small>Max size per file: {{ maxFileSizeLabel }}</small></li>
                        <li><small>Max total size: {{ maxTotalSizeLabel }}</small></li>
                        <li *ngIf="maxFiles !== null">
                            <small>Max files: {{ maxFiles }}{{ existingFileCount > 0 ? ' (' + ((maxFiles - existingFileCount) > 0 ? (maxFiles - existingFileCount) : 0) + ' remaining)' : '' }}</small>
                        </li>
                    </ul>
                </div>

                <div class="mt-1" *ngIf="files.length > 0 || existingTotalBytes > 0">
                    <small class="text-muted">
                        Current selection: {{ formatFileSize(newSelectionBytes) }} |
                        Total attached: {{ formatFileSize(cumulativeTotalBytes) }} / {{ maxTotalSizeLabel }}
                    </small>
                </div>

                <div *ngFor="let error of fileValidationErrors" role="alert">
                    <mat-error>{{ error }}</mat-error>
                </div>

                <div class="file-list-item mt-2" *ngFor="let file of files; let i = index">
                    <span class="file-name">{{ isAutoUploadMode ? getDisplayName(i) : file.name }}</span>
                    <span class="file-size text-muted">{{ formatFileSize(file.size) }}</span>
                    <ng-container *ngIf="isAutoUploadMode">
                        <span *ngIf="getEntryStatus(i) === 'uploading' || getEntryStatus(i) === 'deleting'" class="file-status text-muted">
                            <mat-icon class="file-status-icon spin">sync</mat-icon>
                        </span>
                        <span *ngIf="getEntryStatus(i) === 'uploaded'" class="file-status text-success">
                            <mat-icon class="file-status-icon">check_circle</mat-icon>
                        </span>
                        <span *ngIf="getEntryStatus(i) === 'error'" class="file-status text-danger">
                            <mat-icon class="file-status-icon">error_outline</mat-icon>
                        </span>
                    </ng-container>
                    <button mat-icon-button type="button" aria-label="Remove file" [disabled]="uploading || submitting || getEntryStatus(i) === 'deleting'" (click)="removeSelectedFile(i)">
                        <mat-icon class="material-icons-round">close</mat-icon>
                    </button>
                    <div *ngIf="isAutoUploadMode && getEntryUploadError(i)" class="file-upload-error w-100">
                        <mat-error>{{ getEntryUploadError(i) }}</mat-error>
                    </div>
                    <div *ngIf="isAutoUploadMode && getEntryDeleteError(i)" class="file-upload-error w-100">
                        <mat-error>{{ getEntryDeleteError(i) }} Click the X to try again.</mat-error>
                    </div>
                    <div *ngFor="let err of getFileUploadErrors(i)" class="file-upload-error w-100">
                        <mat-error>{{ err }}</mat-error>
                    </div>
                </div>

                <p class="text-muted mt-2">
                    <small>Accepted types: {{ acceptedExtensions.join(', ') }}</small>
                </p>

                <p class="text-muted mt-3" *ngIf="footerNote">
                    <small>{{ footerNote }}</small>
                </p>
            </div>
        </div>

        <div mat-dialog-actions align="end">
            <button mat-flat-button color="primary" type="button" [disabled]="isBusy" (click)="closeDialog()">
                Cancel
            </button>
            <button
                mat-flat-button
                color="primary"
                type="submit"
                [class.spinner]="uploading || submitting"
                [disabled]="isAutoUploadMode ? (!canSubmit) : (files.length === 0 || fileValidationErrors.length > 0 || uploading)"
            >
                {{ (uploading || submitting) ? 'Uploading…' : 'Upload' }}
            </button>
        </div>
    </form>
</div>
